var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enableCopyright)?_c('div',{ref:"copyrightMask",staticClass:"copyright-mask"},[_c('div',{ref:"copyright",staticClass:"copyright-box"},[_vm._v(_vm._s(_vm.copyright))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }